import { render, staticRenderFns } from "./BookingPatternsChart.vue?vue&type=template&id=f892d4ae"
import script from "./BookingPatternsChart.vue?vue&type=script&lang=js"
export * from "./BookingPatternsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports